import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import TransporteurSelect from 'components/Shared/TransporteurSelect';
import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailCodes } from 'constants.js';

import { getTransporteurEmail } from 'utils/transporteursHelper';

const styles = theme => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    }
});


class OrdreEnlevementMatieresDangeureusesInflammablesDialogContent extends React.Component {

    constructor(props) {
        super(props);

        let state = {
            transporteurId: props.transporteurId,
            destinataires: getTransporteurEmail(props.transporteurId, props.transporteurs, props.depotDepart),
            memo: 'Pour le(s) récépissé(s) ci-dessous :\n',
            fichiersIds: []
        };

        props.colis.forEach(function (coli, index) {
            state.memo += `Colis ${index + 1} : ${coli.numeroTracking} / ${coli.numeroSSCC} / ${coli.numeroSupport}` + (coli.recepisse !== null ? ' / ' + coli.recepisse : '') + '\n';
        });

        this.state = state;
    }
    
    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (newState.transporteurId === -1) {
            return null;
        }
        
        if (newState.destinataires === undefined || newState.destinataires === null || newState.destinataires === '') {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Transporteur,
                type: ReclamationActionDetailType.TransporteurId,
                libelle: 'Transporteur',
                position: 0,
                valeurInteger: newState.transporteurId
            }, {
                    code: ReclamationActionDetailCodes.Email,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Email(s) destinataire(s)',
                    position: 1,
                    valeurString: newState.destinataires
                }, {
                    code: ReclamationActionDetailCodes.Memo,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Mémo',
                    position: 2,
                    valeurString: newState.memo
                }]
        };
        

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {

        const { transporteurs, depotDepart } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (event.target.name === 'transporteurId') {
            newState.destinataires = getTransporteurEmail(newState.transporteurId, transporteurs, depotDepart);
        }
        

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes, transporteurs } = this.props;
        const { transporteurId } = this.state;

        let transporteur = transporteurs.find(x => x.id === transporteurId);

        let transporteurNom = '';

        if (transporteur !== undefined) {
            transporteurNom = transporteur.nom;
        }
        
        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                <Typography variant="body2" gutterBottom className={classes.detailValue}>Envoyer un mail au transporteur ({transporteurNom})</Typography>


                <TransporteurSelect value={transporteurId} onChange={this.handleChange} all={false} isRequired />

                <TextField className={classes.input} id="destinataires" name="destinataires" label='Destinataires du mail (séparé par un ";")' type="text" value={this.state.destinataires} onChange={this.handleChange} fullWidth required />

                <TextField className={classes.input} id="memo" name="memo" label="Mémo" type="text" value={this.state.memo} onChange={this.handleChange} fullWidth multiline />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />

            </DialogContent>
        );
    }
}

OrdreEnlevementMatieresDangeureusesInflammablesDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    transporteurId: PropTypes.number.isRequired,
    transporteurs: PropTypes.array.isRequired
};

export default withStyles(styles)(OrdreEnlevementMatieresDangeureusesInflammablesDialogContent);